import React from "react"
import TrashIcon from "assets/icons/icon-trash.svg"
import { translateText } from "../../../../getTranslationsMyProfileUploadDocumentation"

export const UploadedFileContent = ({ errorMessage, name, onDelete }) => {
    return (
        <div className='uploaded-file__container'>
            <p className={errorMessage && "error"}>{name}</p>
            <button onClick={onDelete}>
                <img src={TrashIcon} alt='trash' />
                <span>{translateText("delete")}</span>
            </button>
        </div>
    )
}
